module.exports = __webpack_public_path__ + "static/Quality-7a408e09fef6066655e67bbbd5dc5554.svg";